import get from 'lodash/get';
import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';
import metricsTracker from 'utils/MetricsTracker';
export function isValidOmnitureInfo(omnitureInfo) {
    return Boolean(typeof omnitureInfo === 'object' &&
        omnitureInfo !== null &&
        typeof omnitureInfo.ingestionEnabled === 'boolean' &&
        omnitureInfo.bucketId);
}
export const APP_LAUNCH_DATA_REQUEST = 'APP_LAUNCH_DATA_REQUEST';
export const APP_LAUNCH_DATA_SUCCESS = 'APP_LAUNCH_DATA_SUCCESS';
export const APP_LAUNCH_DATA_ERROR = 'APP_LAUNCH_DATA_ERROR';
export function appLaunchRequestAction(requestHeaders) {
    return dispatch => {
        dispatch({ type: APP_LAUNCH_DATA_REQUEST });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/app/launch',
            action: APP_LAUNCH_DATA_REQUEST,
            headers: Object.assign({}, headers, requestHeaders)
        })).then(json => {
            const omnitureInfo = get(json, 'RESPONSE.omnitureInfo');
            if (!isValidOmnitureInfo(omnitureInfo)) {
                metricsTracker.setCount(`action.${APP_LAUNCH_DATA_SUCCESS}.INFO_MISSING`);
            }
            return dispatch({ type: APP_LAUNCH_DATA_SUCCESS, data: omnitureInfo });
        }, error => dispatch({ type: APP_LAUNCH_DATA_ERROR, error }));
    };
}
